export function getTestId(elementName: string) {
  return `toast${elementName}`;
}
